import React, { useState, useEffect, Suspense } from 'react';
import { Tabs, Spin } from 'antd';
import Socket from "../../config/socket_services";
import { useAuth } from '../UserAuth/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import commonApiService from '../../config/common_api';

// Lazy load components
const MasterTable = React.lazy(() => import("../MasterTable/MasterTable"));
const KitTable = React.lazy(() => import("../KitTable/KitTable"));
const BundleTable = React.lazy(() => import("../BundleTable/BundleTable"));
const SimpleProductsTable = React.lazy(() => import('../SimpleProductsTable/SimpleTable'));
const VariantTable = React.lazy(() => import('../VariantProductsTable/VariantTable'));
const SampleProductTable = React.lazy(() => import('../SampleProductTable/SampleProductTable'));
const Dashboard = React.lazy(() => import('../Dashboard/Dashboard'));

const Navigation = ({ globalList, setGlobalList }) => {
  const { userData } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Maps for tab routing
  const pathToKeyMap = {
    '/app/dashboard': 'dashboard',
    '/app/home': 'home',
    '/app/kits': 'kits',
    '/app/bundles': 'bundles',
    '/app/simple_products': 'simple_products',
    '/app/sample-promotion-products': 'sample-promotion-products',
    '/app/variants': 'variants',
  };

  const keyToPathMap = Object.fromEntries(
    Object.entries(pathToKeyMap).map(([path, key]) => [key, path])
  );

  // Get current active tab from URL or default to dashboard
  const currentPath = location.pathname;
  const activeTab = pathToKeyMap[currentPath] || 'dashboard';

  // Navigate on tab change
  const onChange = (key) => {
    navigate(keyToPathMap[key]);
  };


  // Fetch common data once on mount
  useEffect(() => {
    const fetchCommonData = async () => {
      try {
        await Promise.all([
          commonApiService.get_stores(),
          commonApiService.GetFrontendTabs(),
          commonApiService.get_sap_skus(),
          commonApiService.get_bc_skus(),
          commonApiService.get_all_category_tree(),
        ]);
      } catch (err) {
        console.error('Error fetching common data', err);
      }
    };
    fetchCommonData();
  }, []);

  // Custom tab bar with socket button
  const customTabBar = (props, DefaultTabBar) => (
    <div className="TabListTopBox">
      <DefaultTabBar {...props} />
      {userData?.data?.access === "ALL" && (
        <div className="SocketBtn">
          <Socket globalList={globalList} setGlobalList={setGlobalList} />
        </div>
      )}
    </div>
  );

  const items = [
    // {
    //   key: 'dashboard',
    //   label: 'Dashboard',
    //   children: <Dashboard globalList={globalList} />,
    // },
    {
      key: 'home',
      label: 'All Products',
      children: <MasterTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
    {
      key: 'kits',
      label: 'Kits',
      children: <KitTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
    {
      key: 'bundles',
      label: 'Bundles',
      children: <BundleTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
    {
      key: 'simple_products',
      label: 'Simple Products',
      children: <SimpleProductsTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
    {
      key: 'variants',
      label: 'Products w/ Variants',
      children: <VariantTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
    {
      key: 'sample-promotion-products',
      label: 'Sample Products',
      children: <SampleProductTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
  ];

  return (
    <div className="TopTablesTabsBox TabNavigation">
      <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}><Spin size="large" /></div>}>
        <Tabs
          activeKey={activeTab}
          onChange={onChange}
          renderTabBar={customTabBar}
          className="TopTablesTabs"
          items={items}
        />
      </Suspense>
    </div>
  );
};

export default Navigation;
